module.exports = __webpack_public_path__ + "media/apps/app_store_button-b2b218ae.png";